import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: 11,
        height: 20,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.397 19.593V9.888h2.905l.385-3.344h-3.29l.005-1.674c0-.872.09-1.34 1.449-1.34h1.815V.187H7.761c-3.49 0-4.718 1.623-4.718 4.35v2.009H.868v3.344h2.175v9.704h4.354Z",
            fill: "#fff"
        })
    }));
};
export default Icon;
